import R from 'app/assets/R'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { useParams } from 'react-router'
import {
  Avatar,
  Degree,
  DirectManager,
  DirectSubordinate,
  MyVoucherList,
  PersonalInformation,
  ReferralList,
  Skill,
  WorkInfo,
} from './components'
import { useModalHook } from './hook'
import * as S from './styles'

const ProfileContainer = () => {
  const {
    profile,
    listWorkInfo,
    listWorkInfoAka,
    referralVoucherList,
    myVoucherList,
  } = useModalHook()

  const { id } = useParams()

  return (
    <S.BaseActionWrapper>
      <HeaderPage titleI18nKey={R.strings.profile} />
      <S.BaseFormWrapper layout="vertical" requiredMark="optional">
        <Avatar profile={profile} />
        <PersonalInformation profile={profile} />
        <Degree profile={profile} />
        {!id && <MyVoucherList data={myVoucherList} />}
        {!id && <ReferralList data={referralVoucherList} />}
        <Skill profile={profile} />
        <WorkInfo
          listWorkInfo={listWorkInfo}
          listWorkInfoAka={listWorkInfoAka}
        />
        <DirectManager profile={profile} />
        <DirectSubordinate managedProfiles={profile?.managedProfiles} />
      </S.BaseFormWrapper>
    </S.BaseActionWrapper>
  )
}

export default ProfileContainer
